<template>
  <div class="monitor">
    <div class="distributed-header">
      <div class="distributed-logo"></div>
      <span class="school">赛点监控</span>
      <span class="word">Match point monitoring</span>
      <div class="header-bottom"></div>
    </div>
    <div class="monitor-info">
      <div class="monitor-list">
        <div class="monitor-box">
          <div class="monitor-header">1号</div>
          <video
            id="webrtc-video"
            class="video"
             src="./../../../assets/video/机器人实操基地12.mp4"
             loop="loop"
            autoplay
            muted
            playsinline
            controls
          ></video>
        </div>
        <div class="monitor-box">
          <div class="monitor-header">2号</div>
          <video
            id="webrtc-video1"
            class="video"
             src="./../../../assets/video/机器人实操基地13.mp4"
             loop="loop"
            autoplay
            muted
            playsinline
            controls
          ></video>
        </div>
        <div class="monitor-box">
          <div class="monitor-header">3号</div>
          <video
            id="webrtc-video2"
            class="video"
             src="./../../../assets/video/机器人实操基地14.mp4"
             loop="loop"
            autoplay
            muted
            playsinline
            controls
          ></video>
        </div>
        <div class="monitor-box">
          <div class="monitor-header">4号</div>
          <video
            id="webrtc-video3"
            class="video"
            src="./../../../assets/video/机器人实操基地1.mp4"
            loop="loop"
            autoplay
            muted
            playsinline
            controls
          ></video>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      url: "http://118.123.247.236:9019",
    };
  },
  methods: {
    getVideo1() {
      let taht = this;
      let webrtc;
      function startPlay() {
        let videoEl = document.querySelector("#webrtc-video");

        webrtc = new RTCPeerConnection({
          iceServers: [
            {
              urls: ["stun:stun.l.google.com:19302"],
            },
          ],
          sdpSemantics: "unified-plan",
        });
        webrtc.onnegotiationneeded = handleNegotiationNeeded;
        webrtc.ontrack = function (event) {
          console.log(event.streams.length + " track is delivered");
          videoEl.srcObject = event.streams[0];
          videoEl.play();
        };
        webrtc.addTransceiver("video", {
          direction: "sendrecv",
        });
        let webrtcSendChannel = webrtc.createDataChannel("sendchannel");
        
        webrtcSendChannel.onclose = () => {
          startPlay();
          console.log("sendChannel has closed");
        };
        webrtcSendChannel.onopen = () => {
          console.log("sendChannel has opened");
          webrtcSendChannel.send("ping");
          setInterval(() => {
            webrtcSendChannel.send("ping");
          }, 1000);
        };

        webrtcSendChannel.onmessage = (e) => console.log(e.data);
      }

      async function handleNegotiationNeeded() {
        let url = taht.url + "/stream/L/channel/bc_b_dx/webrtc";
        let offer = await webrtc.createOffer();

        await webrtc.setLocalDescription(offer);

        fetch(url, {
          method: "POST",
          body: new URLSearchParams({
            data: btoa(webrtc.localDescription.sdp),
          }),
        })
          .then((response) => response.text())
          .then((data) => {
            try {
              // console.log(data);
              webrtc.setRemoteDescription(
                new RTCSessionDescription({
                  type: "answer",
                  sdp: atob(data),
                })
              );
            } catch (e) {
              console.warn(e);
            }
          });
      }

      document.addEventListener("DOMContentLoaded", function () {
        let videoEl = document.querySelector("#webrtc-video");

        videoEl.addEventListener("loadeddata", () => {
          videoEl.play();
        });

        videoEl.addEventListener("error", (e) => {
          console.log("video_error", e);
        });

        startPlay();
      });
    },
    getVideo2() {
      let taht = this;
      let webrtc;
      function startPlay() {
        let videoEl = document.querySelector("#webrtc-video1");

        webrtc = new RTCPeerConnection({
          iceServers: [
            {
              urls: ["stun:stun.l.google.com:19302"],
            },
          ],
          sdpSemantics: "unified-plan",
        });
        webrtc.onnegotiationneeded = handleNegotiationNeeded;
        webrtc.ontrack = function (event) {
          console.log(event.streams.length + " track is delivered");
          videoEl.srcObject = event.streams[0];
          videoEl.play();
        };
        webrtc.addTransceiver("video", {
          direction: "sendrecv",
        });
        let webrtcSendChannel = webrtc.createDataChannel("sendchannel");
        // webrtc.addTransceiver('video', {
        //   'direction': 'sendrecv'
        // });
        webrtcSendChannel.onclose = () => {
          startPlay();
          console.log("sendChannel has closed");
        };
        webrtcSendChannel.onopen = () => {
          console.log("sendChannel has opened");
          webrtcSendChannel.send("ping");
          setInterval(() => {
            webrtcSendChannel.send("ping");
          }, 1000);
        };

        webrtcSendChannel.onmessage = (e) => console.log(e.data);
      }

      async function handleNegotiationNeeded() {
        let url = taht.url + "/stream/L/channel/bc_d_b_xx/webrtc";
        let offer = await webrtc.createOffer();

        await webrtc.setLocalDescription(offer);

        fetch(url, {
          method: "POST",
          body: new URLSearchParams({
            data: btoa(webrtc.localDescription.sdp),
          }),
        })
          .then((response) => response.text())
          .then((data) => {
            try {
              // console.log(data);
              webrtc.setRemoteDescription(
                new RTCSessionDescription({
                  type: "answer",
                  sdp: atob(data),
                })
              );
            } catch (e) {
              console.warn(e);
            }
          });
      }

      document.addEventListener("DOMContentLoaded", function () {
        let videoEl = document.querySelector("#webrtc-video1");

        videoEl.addEventListener("loadeddata", () => {
          videoEl.play();
        });

        videoEl.addEventListener("error", (e) => {
          console.log("video_error", e);
        });

        startPlay();
      });
    },
    getVideo3() {
      let taht = this;
      let webrtc;
      function startPlay() {
        let videoEl = document.querySelector("#webrtc-video2");

        webrtc = new RTCPeerConnection({
          iceServers: [
            {
              urls: ["stun:stun.l.google.com:19302"],
            },
          ],
          sdpSemantics: "unified-plan",
        });
        webrtc.onnegotiationneeded = handleNegotiationNeeded;
        webrtc.ontrack = function (event) {
          console.log(event.streams.length + " track is delivered");
          videoEl.srcObject = event.streams[0];
          videoEl.play();
        };
        webrtc.addTransceiver("video", {
          direction: "sendrecv",
        });
        let webrtcSendChannel = webrtc.createDataChannel("sendchannel");
        // webrtc.addTransceiver('video', {
        //   'direction': 'sendrecv'
        // });
        webrtcSendChannel.onclose = () => {
          startPlay();
          console.log("sendChannel has closed");
        };
        webrtcSendChannel.onopen = () => {
          console.log("sendChannel has opened");
          webrtcSendChannel.send("ping");
          setInterval(() => {
            webrtcSendChannel.send("ping");
          }, 1000);
        };

        webrtcSendChannel.onmessage = (e) => console.log(e.data);
      }

      async function handleNegotiationNeeded() {
        let url = taht.url + "/stream/L/channel/bc_d_n_xx/webrtc";
        let offer = await webrtc.createOffer();

        await webrtc.setLocalDescription(offer);

        fetch(url, {
          method: "POST",
          body: new URLSearchParams({
            data: btoa(webrtc.localDescription.sdp),
          }),
        })
          .then((response) => response.text())
          .then((data) => {
            try {
              // console.log(data);
              webrtc.setRemoteDescription(
                new RTCSessionDescription({
                  type: "answer",
                  sdp: atob(data),
                })
              );
            } catch (e) {
              console.warn(e);
            }
          });
      }

      document.addEventListener("DOMContentLoaded", function () {
        let videoEl = document.querySelector("#webrtc-video2");

        videoEl.addEventListener("loadeddata", () => {
          videoEl.play();
        });

        videoEl.addEventListener("error", (e) => {
          console.log("video_error", e);
        });

        startPlay();
      });
    },
    getVideo4() {
      let taht = this;
      let webrtc;
      function startPlay() {
        let videoEl = document.querySelector("#webrtc-video3");

        webrtc = new RTCPeerConnection({
          iceServers: [
            {
              urls: ["stun:stun.l.google.com:19302"],
            },
          ],
          sdpSemantics: "unified-plan",
        });
        webrtc.onnegotiationneeded = handleNegotiationNeeded;
        webrtc.ontrack = function (event) {
          console.log(event.streams.length + " track is delivered");
          videoEl.srcObject = event.streams[0];
          videoEl.play();
        };
        webrtc.addTransceiver("video", {
          direction: "sendrecv",
        });
        let webrtcSendChannel = webrtc.createDataChannel("sendchannel");
        // webrtc.addTransceiver('video', {
        //   'direction': 'sendrecv'
        // });
        webrtcSendChannel.onclose = () => {
          startPlay();
          console.log("sendChannel has closed");
        };
        webrtcSendChannel.onopen = () => {
          console.log("sendChannel has opened");
          webrtcSendChannel.send("ping");
          setInterval(() => {
            webrtcSendChannel.send("ping");
          }, 1000);
        };

        webrtcSendChannel.onmessage = (e) => console.log(e.data);
      }

      async function handleNegotiationNeeded() {
        let url = taht.url + "/stream/L/channel/bc_n_dx/webrtc";
        let offer = await webrtc.createOffer();

        await webrtc.setLocalDescription(offer);

        fetch(url, {
          method: "POST",
          body: new URLSearchParams({
            data: btoa(webrtc.localDescription.sdp),
          }),
        })
          .then((response) => response.text())
          .then((data) => {
            try {
              // console.log(data);
              webrtc.setRemoteDescription(
                new RTCSessionDescription({
                  type: "answer",
                  sdp: atob(data),
                })
              );
            } catch (e) {
              console.warn(e);
            }
          });
      }

      document.addEventListener("DOMContentLoaded", function () {
        let videoEl = document.querySelector("#webrtc-video3");

        videoEl.addEventListener("loadeddata", () => {
          videoEl.play();
        });

        videoEl.addEventListener("error", (e) => {
          console.log("video_error", e);
        });

        startPlay();
      });
    },
  },
  mounted() {
    // this.getVideo1();
    // this.getVideo2();
    // this.getVideo3();
    // this.getVideo4();
  },
};
</script>
<style scoped>
.monitor {
  width: 100%;
  height: 100%;
  background: url("./../../../assets/img/monitor-bg.png") no-repeat;
  background-size: 100% 100%;
}
.distributed-header {
  width: 100%;
  height: 7.5%;
  position: relative;
  box-sizing: border-box;
  padding-left: 0.05rem;
  display: flex;
}
.header-bottom {
  position: absolute;
  bottom: 0px;
  width: 100%;
  height: 1px;
  background: url("./../../../assets/img/distributed-line.png") no-repeat;
  background-size: 100% 100%;
}
.distributed-header .distributed-logo {
  margin-top: 0.0625rem;
  width: 0.6375rem;
  background: url("./../../../assets/img/distributed-logo.png") no-repeat;
  background-size: 100% 100%;
}
.distributed-header .school {
  font-size: 0.225rem;
  font-family: "pmzd";
  display: flex;
  align-items: center;
  margin: 0 0.0625rem;
  background-image: -webkit-linear-gradient(bottom, #7db2ff, #ffffff);
  -webkit-background-clip: text;
  color: transparent;
}
.distributed-header .word {
  font-family: "SourceHanSansCN";
  color: #9cc3ff;
  font-size: 0.15rem;
  margin-top: 0.0875rem;
}
.monitor-info {
  width: 100%;
  height: 92.5%;
  padding: 0.0625rem 0.1rem 0.1rem 0.1rem;
  box-sizing: border-box;
}
.monitor-info .monitor-list {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-around;
  flex-flow: row wrap;
}
.monitor-box {
  width: 47%;
  height: 47%;
  background: rgba(0, 0, 0, 0.5);
}
.monitor-box .monitor-header {
  padding-left: 0.0375rem;
  padding-top: 1.5%;
  box-sizing: border-box;
  height: 14%;
  background: url("./../../../assets/img/monitor-nav.png");
  background-size: 100% 100%;
  font-size: 0.12rem;
  font-family: "SourceHanSansCN";
  color: #fff;
  overflow: hidden;
  white-space: nowrap;
  display: flex;
  justify-content: center;
  align-items: center;
}
.video {
  width: 100%;
  height: 86%;
}
.video::-webkit-media-controls-timeline {
  display: none;
}
</style>